import { Card, CardContent } from '@/shared/ui/card';
import { PageHeader } from '@/shared/ui/page-header';

export function SignalsDenied() {
  return (
    <div className="space-y-6">
      <PageHeader title="Signals" description="You do not have access to this section." />
      <Card>
        <CardContent className="py-10 text-center text-sm text-muted-foreground">
          Opportunity signals are limited to super admins.
        </CardContent>
      </Card>
    </div>
  );
}
